import React from 'react';

interface BackButtonProps {
  onClick?: () => void;
  style?: React.CSSProperties;
}

/**
 * BackButton - A reusable back navigation button component.
 *
 * Provides a consistent back button interface that can be used across different screens.
 * The button displays a left-pointing arrow icon and "BACK" text.
 *
 * @param onClick - Optional function to handle the back button click event
 * @param style - Optional CSS styles to apply to the button
 *
 * @example
 * ```tsx
 * <BackButton onClick={() => navigate(-1)} />
 * <BackButton onClick={handleBack} style={{ marginTop: '10px' }} />
 * ```
 */
const BackButton: React.FC<BackButtonProps> = ({ onClick, style }) => (
  <button
    className="mtg-back-btn"
    onClick={onClick}
    style={style}
    aria-label="Back"
  >
    <span className="mtg-back-arrow">&larr;</span> BACK
  </button>
);

export default BackButton; 